import { useEffect, useState } from 'react'

function byPosition(rows) {
    return [...rows].sort((one, other) => one.position - other.position)
}

function inOrder(rows, order) {
    if (order == null) {
        return rows
    }

    const byId = new Map(rows.map((row) => [row.id, row]))
    return order.map((id) => byId.get(id)).filter((row) => row != null)
}

function moved(ids, fromId, toId) {
    const from = ids.indexOf(fromId)
    const to = ids.indexOf(toId)

    if (from < 0 || to < 0 || from === to) {
        return null
    }

    const reordered = [...ids]
    reordered.splice(from, 1)
    reordered.splice(to, 0, fromId)
    return reordered
}

export default function useDragReorder({ rows, reorderable, onReorder }) {
    const [order, setOrder] = useState(null)
    const [dragged, setDragged] = useState(null)

    useEffect(() => {
        setOrder(null)
    }, [rows])

    const sorted = inOrder(byPosition(rows), order)

    const drop = (targetId) => {
        if (!reorderable || dragged == null) {
            return
        }

        const reordered = moved(sorted.map((row) => row.id), dragged, targetId)
        setDragged(null)

        if (reordered == null) {
            return
        }

        setOrder(reordered)
        onReorder?.(reordered)
    }

    const rowProps = (id) => ({
        draggable: reorderable,
        onDragStart: () => setDragged(id),
        onDragOver: (event) => event.preventDefault(),
        onDrop: () => drop(id),
        onDragEnd: () => setDragged(null),
    })

    return {
        sorted,
        rowProps,
    }
}
